// @flow
import React, { Component } from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";
import Hammer from "react-hammerjs";
import GalleryPrevious from "./GalleryPrevious";
import GalleryNext from "./GalleryNext";

import { withGlobalContext } from "../common/GlobalContext";
import type { ComplianceListingItems } from "flow/types";
type $Props = {
  classes: Object,
  className: string,
  compliance: ComplianceListingItems,
  photos: Array<string>,
  CDN_IMAGE_SERVER_URL: string,
};

type $State = {
  selectedPhoto: string,
  selectedPhotoIndex: number,
};

class MobileSlideshow extends Component<$Props, $State> {
  constructor(props) {
    super(props);

    this.state = {
      selectedPhoto: props.photos[0] || null,
      selectedPhotoIndex: 1,
    };
  }

  handleSelectPhoto = (photoPath, selectedPhotoIndex) => {
    this.setState({
      selectedPhoto: photoPath,
      selectedPhotoIndex,
    });
  };

  // Handle Next Slideshow Image
  handleNext = (selectedPhotoIndex) => {
    if (!selectedPhotoIndex) {
      return;
    }
    const nextIndex = selectedPhotoIndex + 1;
    const { photos } = this.props;
    // bail if we reached the end
    if (nextIndex > photos.length) {
      return;
    }

    const nextPhoto = photos[nextIndex - 1];

    return this.handleSelectPhoto(nextPhoto, nextIndex);
  };

  // Handle Previous Slideshow Image
  handlePrevious = (selectedPhotoIndex) => {
    if (!selectedPhotoIndex) {
      return;
    }

    const prevIndex = selectedPhotoIndex - 1;

    // bail if a user tries to go beyond the first image
    if (prevIndex < 1) {
      return;
    }
    const { photos } = this.props;
    const prevPhoto = photos[prevIndex - 1];

    return this.handleSelectPhoto(prevPhoto, prevIndex);
  };

  // Handle Swipe on Slideshow
  handleSwipe(e) {
    const { selectedPhotoIndex } = this.state;
    const { photos } = this.props;
    if (e.direction === 4 && selectedPhotoIndex !== 1) {
      return this.handlePrevious(selectedPhotoIndex);
    } else if (e.direction === 2 && selectedPhotoIndex !== photos.length) {
      return this.handleNext(selectedPhotoIndex);
    }
  }

  render() {
    const { classes, className, compliance, photos } = this.props;
    const { selectedPhotoIndex, selectedPhoto } = this.state;
    const watermarkQuery =
      compliance && compliance.photoWatermark
        ? `&mark=${compliance.photoWatermark}&markscale=${compliance.markScale}`
        : "";

    return (
      <div id="slideshow" className={classNames(classes.root, className)}>
        <Hammer onSwipe={(e) => this.handleSwipe(e)}>
          <img
            className={classes.selectedPhoto}
            alt={"listing"}
            src={`${selectedPhoto}&auto=compress&fit=fill&fill-color=000&w=1010&h=670&or=0${watermarkQuery}`}
          />
        </Hammer>
        {selectedPhotoIndex !== 1 && (
          <GalleryPrevious
            handlePrevious={() => this.handlePrevious(selectedPhotoIndex)}
          />
        )}
        {selectedPhotoIndex !== photos.length && (
          <GalleryNext handleNext={() => this.handleNext(selectedPhotoIndex)} />
        )}
        <div className={classes.count}>
          {selectedPhotoIndex} of {photos.length}
        </div>
      </div>
    );
  }
}

export default withStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },
  selectedPhoto: {
    width: "100%",
    height: "auto",
  },
  count: {
    position: "absolute",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    right: "10px",
    padding: theme.spacing.unit * 0.5,
    background: "rgba(0,0,0,0.4)",
    borderBottomRightRadius: "4px",
    borderBottomLeftRadius: "4px",
    color: theme.colors.white,
    fontWeight: "600",
    fontSize: "15px",
    textShadow: "1px 1px 2px rgba(0,0,0,0.15)",
  },
}))(withGlobalContext(MobileSlideshow));
